import type { PermissionActionDef, PermissionCatalog } from '@common/types';

export const PERMISSION_ACTIONS: ReadonlyArray<PermissionActionDef> = [
  { key: 'view', label: 'View' },
  { key: 'create', label: 'Create' },
  { key: 'edit', label: 'Edit' },
  { key: 'delete', label: 'Delete' },
  { key: 'manage', label: 'Manage' },
];

export const ACCOUNT_PERMISSION_CATALOG: PermissionCatalog = [
  {
    key: 'guests',
    label: 'Guests',
    icon: 'groups',
    resources: [
      { key: 'manage-guests', label: 'Manage Guests', actions: ['view', 'create', 'edit', 'delete'] },
      { key: 'unsubscribe', label: 'Unsubscribe', actions: ['view', 'edit'] },
      { key: 'exception-list', label: 'Exception List', actions: ['view', 'create', 'edit', 'delete'] },
    ],
  },
  {
    key: 'reviews',
    label: 'Reviews',
    icon: 'reviews',
    resources: [{ key: 'reviews', label: 'Reviews', actions: ['view', 'edit'] }],
  },
  {
    key: 'service-tickets',
    label: 'Service Tickets',
    icon: 'confirmation_number',
    resources: [
      { key: 'service-tickets', label: 'Tickets', actions: ['view', 'create', 'edit', 'delete', 'manage'] },
    ],
  },
  {
    key: 'reports',
    label: 'Reports',
    icon: 'summarize',
    resources: [
      { key: 'reports-service-rating', label: 'Service Rating', actions: ['view'] },
      { key: 'reports-comprehensive', label: 'Comprehensive', actions: ['view'] },
      { key: 'reports-email-delivery', label: 'Email Delivery', actions: ['view'] },
      { key: 'reports-review-source', label: 'Review Source', actions: ['view'] },
      { key: 'reports-competitor', label: 'Competitor', actions: ['view'] },
      { key: 'reports-tripadvisor', label: 'Tripadvisor', actions: ['view'] },
    ],
  },
  {
    key: 'social-media',
    label: 'Social Media',
    icon: 'share',
    resources: [{ key: 'social-sharing', label: 'Sharing', actions: ['view', 'create'] }],
  },
  {
    key: 'administration',
    label: 'Administration',
    icon: 'admin_panel_settings',
    resources: [
      { key: 'questionnaires', label: 'Questionnaires', actions: ['view', 'edit', 'manage'] },
      { key: 'users', label: 'Users', actions: ['view', 'create', 'edit', 'delete', 'manage'] },
      { key: 'account-profile', label: 'Account Profile', actions: ['view', 'edit'] },
      { key: 'account-preferences', label: 'Account Preferences', actions: ['view', 'edit', 'manage'] },
    ],
  },
];

/**
 * The resources that make up "account settings". A role granting `view` on any
 * of them can open an account's settings page; `edit`/`manage` means it can
 * change them. Kept next to the catalog so the two can't drift apart.
 */
export const ACCOUNT_SETTINGS_RESOURCE_KEYS: ReadonlyArray<string> = [
  'account-profile',
  'account-preferences',
];

export const ORG_PERMISSION_CATALOG: PermissionCatalog = [
  {
    key: 'accounts',
    label: 'Accounts',
    icon: 'apartment',
    resources: [{ key: 'accounts', label: 'Accounts', actions: ['view', 'create', 'edit', 'delete'] }],
  },
  {
    key: 'members',
    label: 'Organization Members',
    icon: 'group',
    resources: [{ key: 'members', label: 'Members', actions: ['view', 'create', 'edit', 'delete'] }],
  },
  {
    key: 'roles',
    label: 'Roles & Permissions',
    icon: 'admin_panel_settings',
    resources: [{ key: 'roles', label: 'Roles', actions: ['view', 'create', 'edit', 'delete', 'manage'] }],
  },
  {
    key: 'billing',
    label: 'Billing & Plan',
    icon: 'credit_card',
    resources: [{ key: 'billing', label: 'Billing', actions: ['view', 'manage'] }],
  },
  {
    key: 'settings',
    label: 'Organization Settings',
    icon: 'settings',
    resources: [{ key: 'org-settings', label: 'Settings', actions: ['view', 'edit'] }],
  },
];
